var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.72 5.14694-11.29331 18.85336c-.23284.4032-.35604.8604-.35734 1.326-.00131.4656.11933.9235.34991 1.328s.56307.7416.96438.9778c.40131.2361.85745.3631 1.32305.3682h22.58671c.4656-.0051.9217-.1321 1.323-.3682.4013-.2362.7338-.5733.9644-.9778s.3512-.8624.3499-1.328-.1245-.9228-.3573-1.326l-11.2934-18.85336c-.2377-.39186-.5723-.71584-.9717-.94069s-.85-.34297-1.3083-.34297-.9089.11812-1.3082.34297c-.3994.22485-.7341.54883-.9718.94069z",
    fill: "#d91507",
    stroke: "#d91507"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 12v5.3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 22.667h.0133"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertFill);
export default __webpack_public_path__ + "static/media/icon_alert_fill.1d2ac6f668feddcd649bb182a6fdc060.svg";
export { ForwardRef as ReactComponent };